import { SyncSlice, ArenaStoreState, ReconnectionPhase } from '../arenaStoreTypes';

export type StoreSet = (
  partial: Partial<ArenaStoreState> | ((state: ArenaStoreState) => Partial<ArenaStoreState>)
) => void;
export type StoreGet = () => ArenaStoreState;

export const initialSyncState = {
  isResyncing: false,
  resyncPhase: 'idle' as ReconnectionPhase,
  resyncMessage: 'Syncing table state...',
  resyncSubMessage: undefined as string | undefined,
  lastStateReceivedTime: 0,
};

export const createSyncSlice = (set: StoreSet, _get: StoreGet): SyncSlice => ({
  ...initialSyncState,

  setIsResyncing: (isResyncing, phase, message, subMessage) =>
    set((state) => ({
      isResyncing,
      resyncPhase:
        phase !== undefined
          ? phase
          : isResyncing
          ? state.resyncPhase === 'idle'
            ? 'syncing'
            : state.resyncPhase
          : 'idle',
      resyncMessage: message !== undefined ? message : state.resyncMessage,
      resyncSubMessage: subMessage !== undefined ? subMessage : state.resyncSubMessage,
    })),

  setResyncPhase: (resyncPhase) => set({ resyncPhase }),
  setResyncMessage: (resyncMessage, resyncSubMessage) => set({ resyncMessage, resyncSubMessage }),
  setLastStateReceivedTime: (lastStateReceivedTime) => set({ lastStateReceivedTime }),
});
